import React from 'react';
import { AlertTriangle, Clock, Lock } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';
import { daysLeft, manilaDate } from '../lib/format';

// Persistent banner for trialing / past_due / suspended / cancelled states
export const SubscriptionBanner = () => {
  const { me, config } = useAuth();
  const shop = me?.shop;
  if (!shop) return null;
  const status = shop.subscription_status;
  const contact = config ? `${config.platform_mobile} / ${config.platform_email}` : '';

  if (status === 'trialing') {
    const d = daysLeft(shop.trial_ends_at);
    return (
      <div data-testid="subscription-banner" className="w-full rounded-xl border px-3 py-2 text-sm flex items-start gap-2 bg-[rgba(14,165,164,0.10)] border-[rgba(14,165,164,0.25)]">
        <Clock className="h-4 w-4 mt-0.5 shrink-0 text-teal-700" />
        <span>Trial — {d} day{d === 1 ? '' : 's'} left. Your shop is on the Pro trial until {manilaDate(shop.trial_ends_at)}.</span>
      </div>
    );
  }
  if (status === 'past_due') {
    return (
      <div data-testid="subscription-banner" className="w-full rounded-xl border px-3 py-2 text-sm flex items-start gap-2 bg-[rgba(253,231,179,0.35)] border-[rgba(138,75,0,0.25)]">
        <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0 text-amber-700" />
        <span>Your {shop.paid_until ? 'subscription ended' : 'trial ended'}. The account becomes read-only on {manilaDate(shop.grace_ends_at)}. Contact us to keep full access: {contact}</span>
      </div>
    );
  }
  if (status === 'suspended' || status === 'cancelled') {
    return (
      <div data-testid="subscription-banner" className="w-full rounded-xl border px-3 py-2 text-sm flex items-start gap-2 bg-[rgba(239,68,68,0.10)] border-[rgba(239,68,68,0.25)]">
        <Lock className="h-4 w-4 mt-0.5 shrink-0 text-red-600" />
        <span>Your account is read-only ({status}). You can view everything but not make changes. Contact us to reactivate: {contact}</span>
      </div>
    );
  }
  return null;
};
